export const formatAmount = (value, { withSymbol = true } = {}) => {
  const num = Number(String(value ?? '').replace(/[₹,]/g, ''));
  if (!Number.isFinite(num)) {
    return withSymbol ? '₹0.00' : '0.00';
  }
  const fixed = num.toFixed(2);
  return withSymbol ? `₹${fixed}` : fixed;
};

export const formatCellValue = (value) => {
  if (value === null || value === undefined || value === '') {
    return '—';
  }
  return value;
};
